/*@ngInject*/
const ModifySubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.modifySubmission = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/modify';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('modifySubmissionRepository', ModifySubmissionRepository);
